<template>
    <project-picker-new v-model="line.project" :ui="crTransUi" />
</template>

<script setup lang="ts">
import {TransactionEntryLine} from '@/types/transaction/TransactionEntryLine'
import ProjectPickerNew from '@/dimensions/ProjectPickerNew.vue'

const line = defineModel<TransactionEntryLine>({required: true})

const crTransUi = {
    content: 'z-1 min-w-fit bg-none',
    trailing: 'absolute right-0 pr-1 bg-none',
    base: 'rounded-none h-8 bg-transparent ring-base-300'
}

</script>

<style>
</style>